import { render } from "./WhatsAppIcon.vue?vue&type=template&id=cce5549a"
import script from "./WhatsAppIcon.vue?vue&type=script&lang=js"
export * from "./WhatsAppIcon.vue?vue&type=script&lang=js"

import "./WhatsAppIcon.vue?vue&type=style&index=0&id=cce5549a&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__